/**
 * initTemplateRoleDrag enables dragging role templates from the template list onto the DWS table.
 * Roles can be dropped into:
 *  - empty cells which will create a new shift
 *  - existing shift which will add a new section
 */

import { templateRoleConfig } from "./droppable_config";
import { createSection } from "./summary_dws_section_drag";

let lastDropTarget = null;
let dropTarget = null;
let ghostRole = null;
let sectionTemplate = null;

export function initTemplateRoleDrag(slotMap, roles) {
  const sectionContainer = document.getElementById('role-template-list');
  if (!sectionContainer) {
    return;
  }

  const draggable = new Draggable.default(sectionContainer, templateRoleConfig);

  // Store the selected template
  sectionContainer?.addEventListener('mousedown', (e) => {
    const el = e.target.closest('.template-slot-list-item.draggable');
    sectionTemplate = el;
  });

  draggable.on('drag:start', (evt) => handleDragStart(evt));
  draggable.on('drag:move', (evt) => handleDragMove(evt));
  draggable.on('drag:stop', () => handleDragStop(slotMap, roles));
}

function handleDragStart(evt) {
  const draggedSection = evt.source;

  // Select the section in the template
  if (sectionTemplate && !sectionTemplate.classList.contains('select')) {
    draggedSection.classList.add("select");
    selectTemplate(sectionTemplate);
  }

  // hide plus buttons
  document.querySelectorAll('.row-btns').forEach(row => {
    row.classList.add("hidden");
  });
}

function handleDragMove(evt) {
  const { clientX, clientY } = evt.sensorEvent;
  dropTarget = document.elementFromPoint(clientX, clientY);
  const dropZone = dropTarget && dropTarget.dataset.user ? dropTarget : undefined;

  // Remove previous ghost if dropZone changed
  if (lastDropTarget && lastDropTarget !== dropZone && ghostRole) {
    ghostRole.remove();
    ghostRole = null;
  }

  // Insert ghost if over a new dropTarget
  if (dropZone && lastDropTarget !== dropZone) {
    ghostRole = evt.source.cloneNode(true);
    ghostRole.classList.add('ghost-role');
    dropZone.appendChild(ghostRole);
    lastDropTarget = dropZone;
  }
}

function handleDragStop(slotMap, roles) {
  const mirror = document.querySelector('.draggable-mirror');
  
  if (!dropTarget || !mirror) {
    cleanupAfterDrag();
    return;
  }

  // Create a new shift if the role was dropped into a cell
  if (dropTarget.dataset.timestamp && dropTarget.dataset.user) {
    handleAddButtonClick(dropTarget.dataset.timestamp, dropTarget.dataset.user, null);
  } 
  // Create a new section if the role was dropped into a shift
  else if (dropTarget.classList.contains('draw-sections')) {
    const mirrorRect = mirror.getBoundingClientRect();
    createSection(dropTarget, mirrorRect, slotMap, roles);
  }

  cleanupAfterDrag();
}

function cleanupAfterDrag() {
  // Remove all ghost roles
  document.querySelectorAll('.ghost-role').forEach(el => el.remove());

  // Add back plus buttons
  document.querySelectorAll('.row-btns').forEach(row => {
    row.classList.remove("hidden");
  });

  ghostRole = null;
  lastDropTarget = null;
  dropTarget = null;
}
